// Module
var code = `<div translate> Supports HTML links <br/> Example: &lt;a href=&quot;https://www.google.com&quot; target=&quot_blank&quot &gt;Link to Google&lt;/a&gt; </div> `;
// Exports
var _module_exports =code;;
var path = '/views/popupHyperlinkInformation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;